import React from "react";
import Accordion from "./common/Accordion";
import { getFormattedDate } from "../../../../actions/common";

const ActivitySummary = ({ customerDetails }) => {
  // Static values for now as requested by user
  const lastInboundDate =
    customerDetails && customerDetails.last_inbound_email_at
      ? getFormattedDate(
          customerDetails.last_inbound_email_at,
          "MMM dd, yyyy 'at' hh:mm a",
        )
      : "--";
  const lastOutboundDate =
    customerDetails && customerDetails.last_outbound_email_at
      ? getFormattedDate(
          customerDetails.last_outbound_email_at,
          "MMM dd, yyyy 'at' hh:mm a",
        )
      : "--";

  const lastMeetingBookedDate =
    customerDetails && customerDetails.last_meeting_booked
      ? getFormattedDate(
          customerDetails.last_meeting_booked,
          "MMM dd, yyyy 'at' hh:mm a",
        )
      : "--";

  // Real value for last activity date if available
  const lastActivityDate =
    customerDetails && customerDetails.lastmodifieddate
      ? getFormattedDate(
          customerDetails.lastmodifieddate,
          "MMM dd, yyyy 'at' hh:mm a",
        )
      : "--";

  return (
    <Accordion header="Activity Summary" targetID="activitySummary">
      <div className="activity-summary-card">
        <div className="activity-item">
          <div className="activity-icon activity">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#5D6D7E"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 6 12 12 16 14"></polyline>
            </svg>
          </div>
          <div className="activity-content">
            <div className="activity-label">LAST ACTIVITY DATE</div>
            <div className="activity-value">{lastActivityDate}</div>
          </div>
        </div>
        <div className="activity-item">
          <div className="activity-icon inbound">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#006EFA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M22 13h-6l-2 3H10l-2-3H2"></path>
              <path d="M5.47 5.19L2 12v5a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5l-3.47-6.81A2 2 0 0 0 16.7 4H7.3a2 2 0 0 0-1.83 1.19z"></path>
            </svg>
          </div>
          <div className="activity-content">
            <div className="activity-label">LAST INBOUND MAIL DATE</div>
            <div className="activity-value">{lastInboundDate}</div>
          </div>
        </div>

        <div className="activity-item">
          <div className="activity-icon outbound">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#27AE60"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
          </div>
          <div className="activity-content">
            <div className="activity-label">LAST OUTBOUND MAIL DATE</div>
            <div className="activity-value">{lastOutboundDate}</div>
          </div>
        </div>
         <div className="activity-item">
          <div className="activity-icon outbound">
            <svg
  width="20"
  height="20"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#8e2fedff"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>

  <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>

  <line x1="16" y1="2" x2="16" y2="6"></line>
  <line x1="8" y1="2" x2="8" y2="6"></line>
  

  <line x1="3" y1="10" x2="21" y2="10"></line>
  
  <circle cx="8" cy="14" r="1" fill="#8e2fedff"></circle>
  <circle cx="12" cy="14" r="1" fill="#8e2fedff"></circle>
  <circle cx="16" cy="14" r="1" fill="#8e2fedff"></circle>
</svg>

          </div>
          <div className="activity-content">
            <div className="activity-label">LAST MEETING BOOKED DATE</div>
            <div className="activity-value">{lastMeetingBookedDate}</div>
          </div>
        </div>
      </div>
    </Accordion>
  );
};

export default ActivitySummary;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/ActivitySummary.js